var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.projectIndicatorSelectList)?_c('ui-dropdown',{attrs:{"isSpecific":_vm.isSpecific,"groupedItems":_vm.projectIndicatorSelectList,"value":_vm.project.id,"dropdownWidth":200,"expanded":""},on:{"input":_vm.onSelectProjectChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }